var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWalk = function SvgWalk(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm-1.16 1.01A1 1 0 0 1 12 8h2a1 1 0 0 1 .8.4l1.29 1.72 1.65.41a1 1 0 1 1-.48 1.94l-2-.5a1 1 0 0 1-.56-.37l-.31-.42-.92 3.07 1.17.98a1 1 0 0 1 .33.53l1 4a1 1 0 1 1-1.94.48l-.92-3.68-2.75-2.3a1 1 0 0 1-.34-.98l.68-3.05-1.03.17-.78 1.55a1 1 0 1 1-1.78-.9l1-2a1 1 0 0 1 .73-.54l3-.5Zm.13 8.9c.1.1.2.2.26.34l-1.3 3.13a1 1 0 0 1-1.85-.76l1.58-3.8 1.3 1.09Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWalk);
export default ForwardRef;